
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    flip: {
      type: Boolean,
      required: false,
      default: false,
    },
    text: {
      type: String,
      required: false,
      default: "",
    },
  },
});
